import { makeStyles, shorthands } from '@fluentui/react-components';
import { customTokens } from 'src/utils/theme';

export const useStyles = makeStyles({
  progressBarWrapper: {
    marginTop: customTokens.spacingVerticalXL,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: customTokens.spacingHorizontalMNudge,
  },
  progressBar: {
    'width': '100%',
    'height': customTokens.spacingVerticalSNudge,
    ...shorthands.border(customTokens.strokeWidthThin, 'solid', customTokens.colorNeutralBackground1),

    '[role=progressbar]': {
      backgroundColor: customTokens.colorBrandBackgroundInvertedHover1,
    },
  },
  overallPercentCompleted: {
    fontSize: customTokens.fontSizeBase400,
    color: customTokens.colorNeutralForeground5,
    lineHeight: customTokens.lineHeightBase400,
  },
});
